import { WidgetConfigReducerState } from "reducers/entityReducers/widgetConfigReducer";
import { WidgetProps } from "widgets/BaseWidget";
import moment from "moment-timezone";
import { generateReactKey } from "utils/generators";

const WidgetConfigResponse: WidgetConfigReducerState = {
  config: {
    BUTTON_WIDGET: {
      text: "Submit",
      buttonStyle: "PRIMARY_BUTTON",
      rows: 1,
      columns: 2,
      widgetName: "Button",
      isDisabled: false,
      isVisible: true,
      isRecaptcha: false,
      isDefaultClickDisabled: true,
      classStyle: "",
    },
    TEXT_WIDGET: {
      text: "Label",
      textStyle: "LABEL",
      textAlign: "LEFT",
      rows: 1,
      columns: 4,
      widgetName: "Text",
      required: false,
      classStyle: "",
    },
    TRANSFORMERS_WIDGET: {
      text: "",
      rows: 1,
      columns: 1,
      widgetName: "Transformers",
    },
    IFRAME_WIDGET: {
      url: "",
      typeWidget: false,
      rows: 5,
      columns: 5,
      widgetName: "Iframe",
      classStyle: "",
    },
    SLIDER_WIDGET: {
      text: [],
      textStyle: "LABEL",
      textAlign: "LEFT",
      rows: 1,
      columns: 4,
      itemsArray: [],
      defaultValue: [],
      widgetName: "Slider",
      onClick: "",
      deleteValue: "",
      classStyle: "",
    },
    LABEL_WIDGET: {
      text: "Label",
      textStyle: "LABEL",
      textAlign: "LEFT",
      rows: 1,
      columns: 4,
      widgetName: "Label",
      classStyle: "",
    },
    FILE_PICKER_S3_WIDGET: {
      text: "FilePicker",
      textStyle: "LABEL",
      uploadUrl: "",
      validType: "",
      textAlign: "LEFT",
      valueRes: null,
      rows: 1,
      columns: 6,
      widgetName: "FilePicker",
      classStyle: "",
    },
    RICH_TEXT_EDITOR_WIDGET: {
      defaultText: "This is the initial <b>content</b> of the editor",
      rows: 5,
      columns: 8,
      isDisabled: false,
      isVisible: true,
      widgetName: "RichTextEditor",
      isDefaultClickDisabled: true,
      classStyle: "",
      direction: false,
    },
    IMAGE_WIDGET: {
      defaultImage:
        "https://res.cloudinary.com/drako999/image/upload/v1589196259/default.png",
      imageShape: "RECTANGLE",
      maxZoomLevel: 1,
      image: "",
      rows: 3,
      columns: 4,
      widgetName: "Image",
      classStyle: "",
    },
    MOB_HEADER_WIDGET: {
      img: "",
      title: "",
      background: "",
      subTitle: "",
      rows: 10,
      columns: 12,
      widgetName: "Header",
      classStyle: "",
    },
    REPEAT_WIDGET: {
      data: [1, 2],
      scroll: false,
      selectedItem: undefined,
      sizeRow: "1",
      rows: 3,
      columns: 4,
      widgetName: "Repeat",
      nameModal: "",
      classStyle: "",
    },
    INPUT_WIDGET: {
      inputType: "TEXT",
      rows: 1,
      label: "",
      columns: 5,
      widgetName: "Input",
      classStyle: "",
    },
    // SWITCH_WIDGET: {
    //   isOn: false,
    //   label: "Switch",
    //   rows: 1,
    //   columns: 4,
    //   widgetName: "Switch",
    // },
    ICON_WIDGET: {
      widgetName: "Icon",
      rows: 1,
      columns: 1,
      classStyle: "",
    },
    CONTAINER_WIDGET: {
      backgroundColor: "#FFFFFF",
      rows: 10,
      columns: 8,
      widgetName: "Container",
      containerStyle: "card",
      children: [],
      blueprint: {
        view: [
          {
            type: "CANVAS_WIDGET",
            position: { top: 0, left: 0 },
            props: {
              containerStyle: "none",
              canExtend: false,
              detachFromLayout: true,
              children: [],
            },
          },
        ],
      },
      classStyle: "",
    },
    FUNCTION_WIDGET: {
      backgroundColor: "#FFFFFF",
      rows: 8,
      widthCustom: 5,
      columns: 4,
      widgetName: "Function_Container",
      containerStyle: "card",
      isMenu: false,
      isRtl: false,
      isOpen: true,
      dontLookPage: [],
      iconHref: "",
      children: [],
      blueprint: {
        view: [
          {
            type: "CANVAS_WIDGET",
            position: { top: 0, left: 0 },
            props: {
              containerStyle: "none",
              canExtend: false,
              detachFromLayout: true,
              children: [],
            },
          },
        ],
      },
      classStyle: "",
    },
    TEMPLATE_WIDGET: {
      rows: 10,
      columns: 8,
      widgetName: "Template",
      containerStyle: "card",
      create: false,
      children: [],
      blueprint: {
        view: [
          {
            type: "CANVAS_WIDGET",
            position: { top: 0, left: 0 },
            props: {
              containerStyle: "none",
              canExtend: false,
              detachFromLayout: true,
              children: [],
            },
          },
        ],
      },
      classStyle: "",
    },
    DATE_PICKER_WIDGET: {
      isDisabled: false,
      datePickerType: "DATE_PICKER",
      rows: 1,
      label: "",
      dateFormat: "DD/MM/YYYY HH:mm",
      columns: 5,
      widgetName: "DatePicker",
      defaultDate: moment().format("DD/MM/YYYY HH:mm"),
      placeholder: "",
      classStyle: "",
    },

    VIDEO_WIDGET: {
      rows: 7,
      columns: 7,
      widgetName: "Video",
      url: "https://www.youtube.com/watch?v=mzqK0QIZRLs",
      autoPlay: false,
      classStyle: "",
    },
    TABLE_WIDGET: {
      rows: 7,
      columns: 8,
      label: "Data",
      widgetName: "Table",
      searchKey: "",
      tableData: [
        {
          id: 2381224,
          email: "michael.lawson@reqres.in",
          userName: "Michael Lawson",
          productName: "Chicken Sandwich",
          orderAmount: 4.99,
        },
        {
          id: 2736212,
          email: "lindsay.ferguson@reqres.in",
          userName: "Lindsay Ferguson",
          productName: "Tuna Salad",
          orderAmount: 9.99,
        },
        {
          id: 6788734,
          email: "tobias.funke@reqres.in",
          userName: "Tobias Funke",
          productName: "Beef steak",
          orderAmount: 19.99,
        },
      ],
      classStyle: "",
      pagination: {
        showing: "Showing",
        separator: "-",
        items: "items",
        page: "Page",
        of: "of",
      },
    },
    DROP_DOWN_WIDGET: {
      rows: 1,
      columns: 5,
      label: "",
      selectionType: "SINGLE_SELECT",
      options: [
        { label: "Vegetarian", value: "VEG" },
        { label: "Non-Vegetarian", value: "NON_VEG" },
        { label: "Vegan", value: "VEGAN" },
      ],
      widgetName: "Dropdown",
      defaultOptionValue: "VEG",
      placeholder: "",
      allowCreate: false,
      createTitle: "",
      query: "",
      classStyle: "",
    },
    CHECKBOX_WIDGET: {
      rows: 1,
      columns: 3,
      label: "Label",
      defaultCheckedState: true,
      widgetName: "Checkbox",
      classStyle: "",
    },
    RADIO_GROUP_WIDGET: {
      rows: 2,
      columns: 3,
      label: "",
      options: [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
      ],
      defaultOptionValue: "M",
      widgetName: "RadioGroup",
      classStyle: "",
    },
    ALERT_WIDGET: {
      alertType: "NOTIFICATION",
      intent: "SUCCESS",
      rows: 3,
      columns: 3,
      header: "",
      message: "",
      widgetName: "Alert",
      classStyle: "",
    },
    FILE_PICKER_WIDGET: {
      rows: 1,
      files: [],
      label: "Select Files",
      columns: 4,
      maxNumFiles: 1,
      maxFileSize: 5,
      widgetName: "FilePicker",
      isDefaultClickDisabled: true,
      classStyle: "",
    },
    ACCORDION_WIDGET: {
      rows: 4,
      files: [],
      label: "Accordion",
      columns: 4,
      onClick: "",
      category: "",
      categoryItem: "",
      categorySubItem: "",
      onClickSub: "",
      onClickMain: "",
      widgetName: "Accordion",
      isVisible: true,
      shouldScrollContents: false,
      directionRtl: false,
      array: [
        {
          label: "Category1",
          value: "1231",
          children: [
            {
              label: "SubCategory1",
              value: "555",
              children: [{ label: "SubItems", value: "546" }],
            },
          ],
        },
        {
          label: "Category2",
          value: "123",
          children: [
            {
              label: "SubCategory2",
              value: "555",
              children: [{ label: "SubItems", value: "546123" }],
            },
          ],
        },
      ],
      classStyle: "",
    },
    TABS_WIDGET: {
      rows: 7,
      columns: 8,
      shouldScrollContents: false,
      widgetName: "Tabs",
      tabs: [
        { label: "Tab 1", id: "tab1", widgetId: "" },
        { label: "Tab 2", id: "tab2", widgetId: "" },
      ],
      shouldShowTabs: true,
      defaultTab: "Tab 1",
      blueprint: {
        operations: [
          {
            type: "MODIFY_PROPS",
            fn: (widget: WidgetProps & { children?: WidgetProps[] }) => {
              const tabs = [...widget.tabs];

              const newTabs = tabs.map((tab: any) => {
                tab.widgetId = generateReactKey();
                return tab;
              });
              const updatePropertyMap = [
                {
                  widgetId: widget.widgetId,
                  propertyName: "tabs",
                  propertyValue: newTabs,
                },
              ];
              return updatePropertyMap;
            },
          },
        ],
      },
      classStyle: "",
    },
    KANBAN_BOARD_WIDGET: {
      rows: 7,
      columns: 8,
      shouldScrollContents: false,
      widgetName: "Kanban",
      kanban: [
        {
          id: "lane1",
          title: "Planned Tasks",
          label: "2/2",
          widgetId: "",
          status: "Planned Tasks",
          cards: [],
        },
        {
          id: "lane2",
          title: "Completed",
          label: "0/0",
          widgetId: "",
          status: "Completed",
          cards: [],
        },
      ],
      cards: [
        {
          id: "Card1",
          title: "Write Blog",
          description: "Can AI make memes",
          label: "30 mins",
          status: "Completed",
          draggable: false,
        },
        {
          id: "Card2",
          title: "Pay Rent",
          description: "Transfer via NEFT",
          label: "5 mins",
          status: "Completed",
          draggable: false,
        },
      ],
      onClick: "{{showModal()}}",
      shouldShowTabs: true,
      mainProperty: "status",
      idCards: "_id",
      title: "title",
      subTitle: "subTitle",
      label: "label",
      value: "",
      blueprint: {
        operations: [
          {
            type: "MODIFY_PROPS",
            fn: (
              widget: WidgetProps & { children?: WidgetProps[] },
              parent?: WidgetProps & { children?: WidgetProps[] },
            ) => {
              const tabs = widget.kanban;

              const newTabs = tabs.map((tab: any) => {
                tab.widgetId = generateReactKey();
                return tab;
              });
              const updatePropertyMap = [
                {
                  widgetId: widget.widgetId,
                  propertyName: "kanban",
                  propertyValue: newTabs,
                },
              ];
              return updatePropertyMap;
            },
          },
        ],
      },
      classStyle: "",
    },
    FILE_MANAGER: {
      rows: 7,
      columns: 8,
      shouldScrollContents: false,
      widgetName: "FileManager",
      onClick: "",
      token: "",
      url: "",
      typeImage: true,
      value: "",
      classStyle: "",
    },
    MODAL_WIDGET: {
      rows: 1000,
      columns: 1000,
      size: "MODAL_SMALL",
      canEscapeKeyClose: true,
      detachFromLayout: true,
      canOutsideClickClose: true,
      shouldScrollContents: true,
      widgetName: "Modal",
      height: 240,
      width: 456,
      isVisible: false,
      children: [],
      blueprint: {
        view: [
          {
            type: "CANVAS_WIDGET",
            position: { left: 0, top: 0 },
            props: {
              detachFromLayout: true,
              canExtend: true,
              isVisible: true,
              isDisabled: false,
              shouldScrollContents: false,
              children: [],
              blueprint: {
                view: [
                  {
                    type: "ICON_WIDGET",
                    position: { left: 14, top: 0 },
                    size: { rows: 1, cols: 2 },
                    props: {
                      iconName: "cross",
                      iconSize: 24,
                      color: "#040627",
                    },
                  },
                  {
                    type: "TEXT_WIDGET",
                    position: { left: 0, top: 0 },
                    size: { rows: 1, cols: 10 },
                    props: {
                      text: "Modal Title",
                      textStyle: "HEADING",
                    },
                  },
                  {
                    type: "BUTTON_WIDGET",
                    position: { left: 10, top: 4 },
                    size: { rows: 1, cols: 3 },
                    props: {
                      text: "Cancel",
                      buttonStyle: "SECONDARY_BUTTON",
                    },
                  },
                  {
                    type: "BUTTON_WIDGET",
                    position: { left: 13, top: 4 },
                    size: { rows: 1, cols: 3 },
                    props: {
                      text: "Confirm",
                      buttonStyle: "PRIMARY_BUTTON",
                    },
                  },
                ],
                operations: [
                  {
                    type: "MODIFY_PROPS",
                    fn: (
                      widget: WidgetProps & { children?: WidgetProps[] },
                      parent?: WidgetProps & { children?: WidgetProps[] },
                    ) => {
                      const iconChild =
                        widget.children &&
                        widget.children.find(
                          child => child.type === "ICON_WIDGET",
                        );

                      if (iconChild && parent) {
                        return [
                          {
                            widgetId: iconChild.widgetId,
                            propertyName: "onClick",
                            propertyValue: `{{closeModal('${parent.widgetName}')}}`,
                          },
                        ];
                      }
                    },
                  },
                ],
              },
            },
          },
        ],
      },
      classStyle: "",
    },
    REPEAT_MODAL_WIDGET: {
      rows: 1000,
      columns: 1000,
      size: "MODAL_SMALL",
      canEscapeKeyClose: true,
      detachFromLayout: true,
      canOutsideClickClose: true,
      shouldScrollContents: true,
      widgetName: "REPEAT_MODAL",
      height: 240,
      width: 456,
      children: [],
      blueprint: {
        view: [
          {
            type: "CANVAS_WIDGET",
            position: { left: 0, top: 0 },
            props: {
              detachFromLayout: true,
              canExtend: true,
              isVisible: true,
              isDisabled: false,
              shouldScrollContents: false,
              children: [],
            },
          },
        ],
      },
    },
    TRANSFORM_WIDGET: {
      text: "",
      expectation: "",
      value: "",
      typeFunction: false,
      rows: 1000,
      columns: 1000,
      widgetName: "TRANSFORM",
    },
    CANVAS_WIDGET: {
      rows: 0,
      columns: 0,
      widgetName: "Canvas",
    },
    CHART_WIDGET: {
      rows: 8,
      columns: 6,
      widgetName: "Chart",
      chartType: "LINE_CHART",
      chartName: "Sales on working days",
      allowHorizontalScroll: false,
      chartData: [
        {
          seriesName: "Sales",
          data: [
            {
              x: "Mon",
              y: 10000,
            },
            {
              x: "Tue",
              y: 12000,
            },
            {
              x: "Wed",
              y: 32000,
            },
            {
              x: "Thu",
              y: 28000,
            },
            {
              x: "Fri",
              y: 14000,
            },
            {
              x: "Sat",
              y: 19000,
            },
            {
              x: "Sun",
              y: 36000,
            },
          ],
        },
      ],
      xAxisName: "Last Week",
      yAxisName: "Total Order Revenue $",
      classStyle: "",
    },
    FORM_BUTTON_WIDGET: {
      rows: 1,
      columns: 3,
      widgetName: "FormButton",
      text: "Submit",
      isDefaultClickDisabled: true,
      classStyle: "",
    },
    FORM_WIDGET: {
      rows: 13,
      columns: 7,
      widgetName: "Form",
      backgroundColor: "white",
      children: [],
      blueprint: {
        view: [
          {
            type: "CANVAS_WIDGET",
            position: { top: 0, left: 0 },
            props: {
              containerStyle: "none",
              canExtend: false,
              detachFromLayout: true,
              children: [],
              blueprint: {
                view: [
                  {
                    type: "TEXT_WIDGET",
                    size: { rows: 1, cols: 12 },
                    position: { top: 0, left: 0 },
                    props: {
                      text: "Form",
                      textStyle: "HEADING",
                    },
                  },
                  {
                    type: "FORM_BUTTON_WIDGET",
                    size: { rows: 1, cols: 4 },
                    position: { top: 11, left: 12 },
                    props: {
                      text: "Submit",
                      buttonStyle: "PRIMARY_BUTTON",
                      disabledWhenInvalid: true,
                      resetFormOnClick: true,
                    },
                  },
                  {
                    type: "FORM_BUTTON_WIDGET",
                    size: { rows: 1, cols: 4 },
                    position: { top: 11, left: 8 },
                    props: {
                      text: "Reset",
                      buttonStyle: "SECONDARY_BUTTON",
                      disabledWhenInvalid: false,
                      resetFormOnClick: true,
                    },
                  },
                ],
              },
            },
          },
        ],
      },
      classStyle: "",
    },
    MAP_WIDGET: {
      rows: 12,
      columns: 8,
      isDisabled: false,
      isVisible: true,
      widgetName: "Map",
      enableSearch: true,
      zoomLevel: 50,
      enablePickLocation: true,
      allowZoom: true,
      mapCenter: { lat: -34.397, long: 150.644 },
      defaultMarkers: [{ lat: -34.397, long: 150.644, title: "Test A" }],
      classStyle: "",
    },
    SKELETON_WIDGET: {
      isLoading: true,
      rows: 1,
      columns: 1,
      widgetName: "Skeleton",
    },
  },
  configVersion: 1,
};

export default WidgetConfigResponse;
